
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class IconSubtitle extends Vue {
  @Prop() readonly text!: string;
  @Prop() readonly icon!: string;
}
